// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"5075d68e","426":"181d8e6d","453":"2f44fb42","461":"f89b2ff0","561":"e7a89014","619":"29fff2fa","788":"e0648704","881":"15508a45"}[chunkId] + ".chunk.js";
};